"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cols-form tab-card-validation-documents-component"
  }, [_c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [!_vm.hasDocumentContent ? _c("not-found") : _c("card", {
    staticClass: "card-detail-image biometric-validation-card"
  }, [_c("div", {
    staticClass: "document-validation"
  }, [_c("div", {
    staticClass: "document-validation__hero"
  }, [_c("div", {
    staticClass: "document-validation__media"
  }, [_vm.coverDocumentImage ? _c("img", {
    staticClass: "img-raised",
    attrs: {
      src: _vm.coverDocumentImage
    },
    on: {
      click: function click($event) {
        return _vm.openModal(_vm.normalizedDocumentItems[0]);
      }
    }
  }) : _c("img", {
    staticClass: "img-raised",
    attrs: {
      src: require("@/assets/images/avatar-default.png")
    }
  }), _vm._v(" "), _vm.coverDocumentImage ? _c("button", {
    staticClass: "button is-small document-validation__preview-button",
    on: {
      click: function click($event) {
        return _vm.openModal(_vm.normalizedDocumentItems[0]);
      }
    }
  }, [_vm._v("\n                Ampliar documento\n              ")]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "document-validation__summary"
  }, [_c("div", {
    staticClass: "document-validation__eyebrow"
  }, [_vm._v("\n                Resultado da Análise Documental\n              ")]), _vm._v(" "), _c("div", {
    staticClass: "document-validation__headline"
  }, [_c("div", [_c("h2", [_vm._v(_vm._s(_vm.documentSummary.title))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.documentSummary.description))])]), _vm._v(" "), _c("span", {
    class: ["tag", "document-validation__status-chip", _vm.documentSummary.tagClass]
  }, [_c("b-icon", {
    attrs: {
      icon: _vm.documentSummary.icon,
      size: "is-small"
    }
  }), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.documentSummary.tagLabel))])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "document-validation__meta"
  }, [_vm.reasonDocument ? _c("div", {
    staticClass: "document-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "file-document",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Análise documental")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.reasonDocument))])])], 1) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "document-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "file-multiple",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Documentos enviados")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.normalizedDocumentItems.length))])])], 1)])])]), _vm._v(" "), _c("div", {
    staticClass: "document-validation__content"
  }, [_vm.normalizedDocumentItems.length ? _c("section", {
    staticClass: "document-validation__section"
  }, [_c("div", {
    staticClass: "document-validation__section-header"
  }, [_c("div", {
    staticClass: "document-validation__section-title"
  }, [_c("b-icon", {
    attrs: {
      icon: "card-account-details"
    }
  }), _vm._v(" "), _c("h3", [_vm._v("Documentos de identificação")])], 1), _vm._v(" "), _c("p", [_vm._v("Arquivos utilizados na análise do documento, com leitura organizada por tipo.")])]), _vm._v(" "), _c("div", {
    staticClass: "document-validation__grid"
  }, _vm._l(_vm.normalizedDocumentItems, function (itemValidation) {
    return _c("div", {
      key: itemValidation.key,
      staticClass: "document-validation__item-card"
    }, [_c("div", {
      staticClass: "document-validation__item-head"
    }, [_c("div", {
      staticClass: "document-validation__item-icon"
    }, [_c("b-icon", {
      attrs: {
        icon: "image"
      }
    })], 1), _vm._v(" "), _c("span", {
      staticClass: "tag document-validation__item-tag is-info"
    }, [_vm._v("\n                      " + _vm._s(itemValidation.type) + "\n                    ")])]), _vm._v(" "), _c("div", {
      staticClass: "document-validation__item-image"
    }, [_c("img", {
      attrs: {
        src: itemValidation.src
      },
      on: {
        click: function click($event) {
          return _vm.openModal(itemValidation);
        }
      }
    })]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(itemValidation.label))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(itemValidation.helper))])]);
  }), 0)]) : _vm._e()])])])], 1)]), _vm._v(" "), _c("b-modal", {
    model: {
      value: _vm.isImageModalActive,
      callback: function callback($$v) {
        _vm.isImageModalActive = $$v;
      },
      expression: "isImageModalActive"
    }
  }, [_c("p", {
    staticClass: "image"
  }, [_c("img", {
    staticClass: "img-render-large",
    attrs: {
      src: _vm.imgSelected
    }
  })])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;